import classNames from 'classnames'
import type { CSSProperties, FC } from 'react'
import React from 'react'
import styles from './MapTooltip.module.scss'
import { LoadingIndicator } from '@/tools/ui'

type Props = {
  title: string
  isLoading?: boolean
  actionText?: string
  description?: string
  onActionClick?: () => void
  icon?: React.ReactNode
  width?: number | string
  children?: null
  style?: CSSProperties
  className?: string
}
export const MapTooltip: FC<Props> = ({
  title,
  isLoading,
  description,
  actionText,
  onActionClick,
  icon,
  width = 'auto',
  children,
  style,
  className = '',
}) => {
  const handleOnclick = () => {
    if (!onActionClick) {
      return
    }
    onActionClick()
  }

  return (
    <div
      className={classNames({
        [styles.mapTooltip]: true,
        [className]: !!className,
      })}
      data-testid="map-tooltip"
      style={{ maxWidth: width, ...style }}
    >
      {isLoading ? (
        <LoadingIndicator className={styles.loadingIndicator} size="m" />
      ) : (
        <div className={styles.tooltipContent}>
          {icon && icon}
          <div>
            <h4 className={styles.tooltipTitle}>{title}</h4>
            {description && <p className={styles.tooltipDescription}>{description}</p>}
            {actionText && (
              <p
                className={styles.tooltipAction}
                role="button"
                tabIndex={0}
                onClick={handleOnclick}
              >
                {actionText}
              </p>
            )}
            {children}
          </div>
        </div>
      )}
      <div className={styles.tooltipPointer}></div>
    </div>
  )
}
export type MapTooltipProps = Props
